import React from "react";
import { useIntl } from "react-intl";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";

export default function InfluencerCountryInput({
  countryInputValue,
  onCountryInputValueChange,
  isDisabled,
}) {
  const intl = useIntl();
  return (
    <div className="audience-search__input">
      <div className="idh-label idh-label--with-tooltip">
        <IDHFormattedMessage
          id="front_influencer_country"
          defaultMessage="Creator Country"
        />
        <MaterialTooltip
          id="front_influencer_country_tooltip"
          content={
            <IDHFormattedMessage
              id="front_influencer_country_tooltip"
              defaultMessage="Here, you can specify the country of the influencer."
            />
          }
        />
      </div>
      <input
        placeholder={intl.formatMessage({
          id: "front_enter_country_name_placeholder",
          defaultMessage: "Enter country",
        })}
        value={countryInputValue}
        onChange={onCountryInputValueChange}
        data-cdt-input="countries"
        disabled={isDisabled}
      />
    </div>
  );
}
